export default {
  computed: {
    USER_STATUS_NEW() {
      return "NEW";
    },

    USER_STATUS_FILLED() {
      return "FILLED";
    },

    USER_STATUS_VERIFIED() {
      return "VERIFIED";
    },

    USER_STATUS_RECHECK() {
      return "RECHECK";
    },

    USER_STATUS_DELETED() {
      return "DELETED";
    },

    USER_STATUS_PENDING_DELETION() {
      return "PENDING_DELETION";
    },

    userStatuses() {
      return [
        {
          text: this.getUserStatusText(this.USER_STATUS_NEW),
          value: this.USER_STATUS_NEW,
        },
        {
          text: this.getUserStatusText(this.USER_STATUS_FILLED),
          value: this.USER_STATUS_FILLED,
        },
        {
          text: this.getUserStatusText(this.USER_STATUS_VERIFIED),
          value: this.USER_STATUS_VERIFIED,
        },
        {
          text: this.getUserStatusText(this.USER_STATUS_RECHECK),
          value: this.USER_STATUS_RECHECK,
        },
        {
          text: this.getUserStatusText(this.USER_STATUS_DELETED),
          value: this.USER_STATUS_DELETED,
        },
        {
          text: this.getUserStatusText(this.USER_STATUS_PENDING_DELETION),
          value: this.USER_STATUS_PENDING_DELETION,
        },
      ];
    },

    editableUserStatuses() {
      return this.userStatuses.filter(
        (item) =>
          item.value !== this.USER_STATUS_DELETED &&
          item.value != this.USER_STATUS_PENDING_DELETION,
      );
    },
  },

  methods: {
    isUserDeleted(user) {
      if (!user) {
        return false;
      }

      return user.status === this.USER_STATUS_DELETED || !!user.deleted_at;
    },

    getUserStatusColor(value) {
      if (value === this.USER_STATUS_VERIFIED) return "green";
      else if (value === this.USER_STATUS_FILLED) return "amber darken-1";
      else if (value === this.USER_STATUS_NEW) return "purple";
      else if (value === this.USER_STATUS_RECHECK) return "cyan darken-1";
      else if (value === this.USER_STATUS_DELETED) return "grey darken-1";
      else if (value === this.USER_STATUS_PENDING_DELETION)
        return "grey darken-1";
      else return "gray";
    },

    getUserStatusText(value) {
      if (value === this.USER_STATUS_VERIFIED) return "Проверен";
      else if (value === this.USER_STATUS_FILLED) return "Заполнен";
      else if (value === this.USER_STATUS_NEW) return "Новый";
      else if (value === this.USER_STATUS_RECHECK)
        return "Отправить на перепроверку";
      else if (value === this.USER_STATUS_DELETED) return "Удален";
      else if (value === this.USER_STATUS_PENDING_DELETION)
        return "Очередь на удаление";
      else return `Неизвестный статус ${value}`;
    },
  },
};
